import React from 'react';
import { Alert, ConfigProvider } from 'antd';
import s from './s.module.less';

interface PrefillNoticeProps {
    message?: React.ReactNode;
    className?: string;
    closable?: boolean;
    onClose?: () => void;
}

const DEFAULT_MESSAGE =
    'Your practice admin has pre-filled some of your profile details. Please review the info to ensure everything is accurate, and add any missing details needed to complete your profile.';

const PrefillNotice: React.FC<PrefillNoticeProps> = ({
    message = DEFAULT_MESSAGE,
    className,
    closable = true,
    onClose,
}) => {
    return (
        <ConfigProvider theme={{ token: { colorPrimary: '#0E62F4' } }}>
            <Alert
                className={`${s.notice} ${className || ''}`}
                type="info"
                showIcon
                closable={closable}
                onClose={onClose}
                message={message}
            />
        </ConfigProvider>
    );
};

export default PrefillNotice;
